/**
 * CagesTable - Handsontable table component for cage creation.
 * Uses editors, validators, and renderers via Spreadsheet.
 */
import type { FC, ReactNode, RefObject } from 'react';

import type { MetadataField } from '@/model/Metadata.model';

import Spreadsheet from '@/components/UI/SpreadSheet/Spreadsheet';
import type { SpreadsheetSettings } from '@/components/UI/SpreadSheet/SpreadSheet.model';
import type { HotTableRef } from '@/components/UI/SpreadSheet/HotTable';
import { defaultMetadataToColumnSettingMapper } from '@/support/hot';

interface CagesTableProps {
  data: Array<Record<string, unknown>>;
  innerRef: RefObject<HotTableRef | null>;
  settings: SpreadsheetSettings;
  setSettings: (settings: SpreadsheetSettings) => void;
  metadata: Array<MetadataField>;
  setMetadata: (metadata: Array<MetadataField>) => void;
  setInvalid: (invalid: boolean) => void;
  overlay?: ReactNode;
  maxRows?: number;
  afterRemoveRow?: () => void;
  afterContextMenuHide?: () => void;
}

const CagesTable: FC<CagesTableProps> = ({
  data,
  innerRef,
  settings,
  setSettings,
  metadata,
  setMetadata,
  setInvalid,
  overlay,
  maxRows,
  afterRemoveRow,
  afterContextMenuHide,
}) => {
  return (
    <Spreadsheet
      className="cageCreation"
      testPrefix="cage-creation"
      data={data}
      innerRef={innerRef as RefObject<HotTableRef>}
      settings={settings}
      setSettings={setSettings}
      metadata={metadata}
      setMetadata={setMetadata}
      metadataToColumnSettingMapper={defaultMetadataToColumnSettingMapper}
      setInvalid={setInvalid}
      overlay={overlay}
      maxRows={maxRows}
      afterRemoveRow={afterRemoveRow}
      afterContextMenuHide={afterContextMenuHide}
      buttonClasses="absolute-sheet-buttons"
    />
  );
};

export default CagesTable;
